<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('accounting.exchange_transaction.exchange_transaction') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('accounting.exchange_transaction.exchange_transaction'),
            active: true
          }
        ]"
      />
    </div>
    <panel
      :title="$t('accounting.exchange_transaction.form')"
      variant="default"
    >
      <form-create @fetch_data="fetchData"></form-create>
    </panel>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10">
            <form class="form-horizontal">
              <div class="d-flex">
                <div class="d-flex align-items-center">
                  <label class="col-md-4 form-col-label control-label">Date From</label>
                  <ts-date-picker-input v-model="date_from" />
                </div>
                <div class="d-flex align-items-center">
                  <label class="col-md-4 form-col-label control-label">Date To</label>
                  <ts-date-picker-input v-model="date_to" />
                </div>
              </div>
            </form>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'created_date'
        }"
      >
        <template v-slot="{ record }">
          <td :style="rowStyle(record.amount_due)">
            {{ record.reference_number }}
          </td>
          <td :style="rowStyle(record.amount_due)">
            {{ record.customer.customer_name }}
          </td>
          <td :style="rowStyle(record.amount_due)">
            {{ record.employee.name_en }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            {{
              formatCurrency(
                record.amount_in,
                record.from_currency.currency_code
              )
            }}
            {{ record.from_currency.currency_code }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            {{ record.rate_amount }} {{ record.to_currency.currency_code }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            {{
              formatCurrency(
                record.amount_out,
                record.to_currency.currency_code
              )
            }}
            {{ record.to_currency.currency_code }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            {{
              formatCurrency(
                record.amount_taken,
                record.to_currency.currency_code
              )
            }}
            {{ record.to_currency.currency_code }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            {{
              formatCurrency(
                record.amount_due,
                record.to_currency.currency_code
              )
            }}
            {{ record.to_currency.currency_code }}
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            <span class="text-success" v-if="record.all_taken"
              ><i class="fa fa-check"></i
            ></span>
          </td>
          <td :style="rowStyle(record.amount_due)" class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import moment from 'moment'

export default {
  components: {
    FormCreate
  },
  name: 'exchange-transaction',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('exchangeTransaction', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeTransaction.search
      },
      set(newValue) {
        this.$store.commit('exchangeTransaction/SET_SEARCH', newValue)
        this.$store.commit('exchangeTransaction/RESET_CURRENT_PAGE')
      }
    },
    date_from: {
      get() {
        return this.$store.state.exchangeTransaction.date_from
      },
      set(val) {
        this.$store.commit('exchangeTransaction/SET_DATE_FROM', val)
      }
    },

    date_to: {
      get() {
        return this.$store.state.exchangeTransaction.date_to
      },
      set(val) {
        this.$store.commit('exchangeTransaction/SET_DATE_TO', val)
      }
    },
    rowStyle: () => amount_due => {
      let value = ''
      let color = ''
      if (parseFloat(amount_due) != 0) {
        value = 700
        color = '#343a40'
      }
      return {
        'font-weight': value,
        color: color
      }
    },
    columns() {
      return [
        {
          name: this.$t('accounting.exchange_transaction.reference_number'),
          style: 'width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.customer_name')
        },
        {
          name: this.$t('accounting.exchange_transaction.employee_name'),
          style: 'width:12%'
        },
        {
          name: this.$t('accounting.exchange_transaction.amount_in'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.rate_amount'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.amount_out'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.amount_taken'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.amount_due'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('accounting.exchange_transaction.all_taken'),
          style: 'text-align:center; width:8%'
        },
        {
          name: this.$t('accounting.exchange_transaction.actions'),
          style: 'text-align:center; width:5%'
        }
      ]
    }
  },
  created() {
    this.date_from = moment().add(-7, 'd').format('DD-MM-YYYY')
    this.date_to = moment().format('DD-MM-YYYY')
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeTransaction/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    formatCurrency(value, currency_code) {
      let val = null
      currency_code.toLowerCase() == 'khr'
        ? (val = (value / 1).toFixed(0).replace(',', '.'))
        : (val = (value / 1).toFixed(2).replace(',', '.'))
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    edit(record) {
      this.$store.commit('exchangeTransaction/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'exchange-transaction-edit',
        params: { id: record.exc_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    date_from: function(date) {
      this.fetchData()
    },
    date_to: function(date) {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'exchange-transaction') {
      this.$store.commit('exchangeTransaction/RESET_STATE')
      this.$store.commit('exchangeTransaction/SET_EDIT_DATA', {})
      this.$store.commit('exchangeTransaction/SET_CUSTOMERS', [])
      this.$store.commit('exchangeTransaction/SET_EMPLOYEES', [])
      this.$store.commit('exchangeTransaction/SET_CURRENCIES', [])
    }
    next()
  }
}
</script>
